import IconClose from '../../assets/icons/close.svg?react'
import { useTransition } from '@react-spring/web'
import { useTranslation } from 'react-i18next'

import Link from '../Link'
import { Root, Container, LinkContainer, CloseButton } from './style'
import { ANIMATION_DISABLED_DURATION } from '../../constants/animation'

const CookieBanner = ({ onClose, show, animationDisabled }) => {
  const { t } = useTranslation()
  const transitions = useTransition(show ? [1] : [], {
    from: {
      height: '58px',
      transform: 'translateY(0px)',
    },
    enter: {
      height: '58px',
      transform: 'translateY(0px)',
    },
    leave: {
      height: '0',
      transform: 'translateY(58px)',
    },
    config: { duration: animationDisabled ? ANIMATION_DISABLED_DURATION : undefined },
  })
  return (
    <>
      {transitions(
        (style, item) =>
          item && (
            <Root style={style}>
              <Container data-testid="cookie-consent-banner">
                <LinkContainer>
                  <Link
                    newTab
                    textLink
                    href="https://www.capgemini.com/privacy-policy/"
                    data-testid="privacy-policy-link"
                  >
                    {t('content.cookieBanner')}
                  </Link>
                </LinkContainer>
                <CloseButton
                  onClick={onClose}
                  aria-label="close cookie notice"
                  data-testid="dismiss-cookie-banner-button"
                >
                  <IconClose />
                </CloseButton>
              </Container>
            </Root>
          )
      )}
    </>
  )
}

export default CookieBanner
